import React, { Component } from 'react';
import { connect } from 'react-redux';
import { HashRouter, Route, Redirect } from 'react-router-dom';
import { TransitionGroup } from 'react-transition-group';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Loader } from 'common/components';
import { ROOT_ROUTE, CATEGORY_ROUTE, THANKS_ROUTE, CLOSED_VOTES_ROUTE, CHOICE_ROUTE } from 'client/constants';
import * as actions from 'client/actions';
import { RouterSwitch, Fade, PopUpManager } from 'client/components/common';
import MainPage from 'client/components/pages/MainPage';
import Category from 'client/components/pages/Category';
import ResultPage from 'client/components/pages/ResultPage';
import ClosedVotes from 'client/components/pages/ClosedVotes';
import ChoicePage from 'client/components/pages/ChoicePage';

import './App.scss';

class App extends Component {
	static propTypes = {
		settings: PropTypes.shape({
			general: PropTypes.shape({
				gaId: PropTypes.string,
			}),
		}).isRequired,
		init: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			isStarted: false,
		};
	}

	async componentDidMount() {
		// await this.props.checkAuthState();
		// if (localStorage.getItem('isLogedInFestigal') === 'false' || !localStorage.getItem('isLogedInFestigal')) {
		// 	await this.props.logout();
		// }
		await this.props.init();
		this.setState({ isStarted: true });
		this.removeRootPreloader();
	}

	removeRootPreloader = () => {
		const preloadingScreen = document.querySelector('.preloading-screen');

		if (preloadingScreen) {
			preloadingScreen.addEventListener('transitionend', e => {
				if (e.target === preloadingScreen) {
					preloadingScreen.remove();
				}
			});
			preloadingScreen.style.opacity = 0;
			clearInterval(window.preloaderID);
		}
	};

	resetScroll = () => window.scrollTo(0, 0);

	onRouterSwitchUpdate = () => {
		this.resetScroll();
	};

	renderLoader = () => (
		<Fade customKey="rootLoader">
			<Loader type="ball-grid-pulse" fullScreen />
		</Fade>
	);

	renderRoute = props => {
		const { isStarted } = this.state;

		switch (props.match.path) {
			case ROOT_ROUTE:
				return (
					<TransitionGroup appear enter exit>
						<MainPage key={props.location.pathname} {...props} isStarted={isStarted} />
					</TransitionGroup>
				);
			case CATEGORY_ROUTE:
				return (
					<TransitionGroup appear enter exit>
						<Category key={props.location.pathname} {...props} isStarted={isStarted} />
					</TransitionGroup>
				);
			case THANKS_ROUTE:
				return (
					<TransitionGroup appear enter exit>
						<ResultPage key={props.location.pathname} {...props} isStarted={isStarted} />
					</TransitionGroup>
				);
			case CLOSED_VOTES_ROUTE:
				return (
					<TransitionGroup appear enter exit>
						<ClosedVotes key={props.location.pathname} {...props} isStarted={isStarted} />
					</TransitionGroup>
				);
			case CHOICE_ROUTE:
				return (
					<TransitionGroup appear enter exit>
						<ChoicePage key={props.location.pathname} {...props} isStarted={isStarted} />
					</TransitionGroup>
				);
			default:
				return null;
		}
	};

	render() {
		return (
			<HashRouter>
				<React.Fragment>
					<RouterSwitch onUpdate={this.onRouterSwitchUpdate}>
						{/* <Route exact path={ROOT_ROUTE} render={this.renderRoute} />
						<Route exact path={CHOICE_ROUTE} render={this.renderRoute} />
						<Route exact path={CATEGORY_ROUTE} render={this.renderRoute} />
						<Route exact path={THANKS_ROUTE} render={this.renderRoute} /> */}
						<Route exact path={CLOSED_VOTES_ROUTE} render={this.renderRoute} />
						<Redirect to={CLOSED_VOTES_ROUTE} />
					</RouterSwitch>
					<PopUpManager />
				</React.Fragment>
			</HashRouter>
		);
	}
}

export default connect(
	state => ({
		settings: _.get(state, 'settings', {}),
	}),
	dispatch => ({
		init: () => dispatch(actions.init()),
	})
)(App);
